import script from "./CarouselHome.component.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselHome.component.vue?vue&type=script&setup=true&lang=js"

import "./CarouselHome.component.vue?vue&type=style&index=0&id=773c8b79&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773c8b79"]])

export default __exports__